import { ReviewStatus } from 'app/developer-v3/types/statuses';
import {
  useQueryIssues,
  useQueryIntegrationReview,
} from 'app/developer-v3/hooks';

export default function useAppBuilderPageData(integrationId: number) {
  const queryIssues = useQueryIssues({
    actions: [],
    integrationId,
    orderBy: 'priority',
    orderDirection: 'ASC',
    page: 1,
  });
  const issuesCount = queryIssues.data?.count ?? 0;

  const queryIntegrationReview = useQueryIntegrationReview({ integrationId });
  const reviewStatus =
    queryIntegrationReview.data?.status ?? ReviewStatus.notSubmitted;

  return {
    hasIssues: issuesCount > 0,
    issuesCount,
    isLoading: queryIssues.isLoading || queryIntegrationReview.isLoading,
    error: {
      errorIntegration: queryIssues.error,
      errorIntegrationReview: queryIntegrationReview.error,
    },
    reviewStatus,
  };
}
